import { render, staticRenderFns } from "./StoreDiscountLists.vue?vue&type=template&id=d0d46690"
import script from "./StoreDiscountLists.vue?vue&type=script&lang=js"
export * from "./StoreDiscountLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports